export default __webpack_public_path__ + "static/media/image_1.ca64008c.jpg";